import { GeoCoord } from '@/rec-cache/rec-cache-geo'
import { Iri, Iris } from '@/rec-cache/rec-cache-types'

function geoCoordinateParser(individual) {
  if (individual.type.value == Iris.recPoint) {
    const coordinates = individual.getProperty(new Iri(Iris.recCoordinates))
    const [coordinate] = coordinates.values
    const [long, lat] = JSON.parse(coordinate.value)
    return new GeoCoord(lat, long)
  }
  return null
}

/*
const asWktIri = 'http://www.opengis.net/ont/geosparql#asWKT'

function geoCoordinateParser(individual) {
  // A match returns an array of three elements; the match itself, 1st capturing group and 2nd capturing group.
  const pointRegex = /POINT\s*\(\s*(-?\d+\.?\d+)\s*,*\s*(-?\d+\.?\d+)\s*\)/
  const wktProperty = individual.getProperty(new Iri(asWktIri))
  if (wktProperty) {
    try {
      // If several valid WKT strings are set the first matched point will be returned (the point may however not be the first value).
      const match = wktProperty.values
        .map((v) => v.value.trim().toUpperCase().match(pointRegex))
        .find((m) => !!m)
      if (!match) return null
      const [, long, lat] = match
      return new GeoCoord(lat, long)
    } catch (error) {
      console.error(
        'wob-client.wob-client-geo-coordinate-parser.error',
        wktProperty.values.map((v) => v.value),
        error
      )
    }
  }
  return null
}
*/

export { geoCoordinateParser }
